import { gql } from '@apollo/client';

export const GET_ERROR_MESSAGES_FOR_PROJECT = gql`
  query GetErrorMessagesForProject($input: FailedMessagesInput!) {
    getErrorMessagesForProject(input: $input) {
      errorCounter
      vendorDataContractErrorList {
        date
        errorMessage
        messageId
        payload
      }
    }
  }
`;
